import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next'
import React, { useEffect, useState } from 'react'

import { MOBILE_VIEW_BREAKPOINT } from '../../constants'
import useHomepage from '../../hooks/useHomepage'
import Logo from '../../images/logo.svg'
import WhiteLogo from '../../images/white-logo.svg'
import UtmContent from '../../models/UtmContent'
import { AnalyticsService, UrlService } from '../../services'
import CateringBanner from './CateringBanner'
import DeliveryBanner from './DeliveryBanner'
import DropdownMenu from './DropdownMenu'
import HomepageTopBanner from './HomepageTopBanner'
import DinnerBanner from './SuburbBanner'
import './header.less'

const Header = () => {
  const { t } = useTranslation()
  const {
    productOffering,
    activeCityName,
    logInEnabled,
    onNyLunchPage,
    onSfLunchPage,
    onFiveReasonsPage,
    onPartnerPage,
    landingPageAlias,
    isLunchForLessPage,
    isGreenPage,
  } = useHomepage()
  const language = useI18next().language
  const root = language === 'us' ? '/' : `/${language}/`
  const lunchBannerRequired = typeof window !== 'undefined' && window.location.pathname === '/'
  const deliveryBannerRequired = productOffering === 'delivery'
  const dinnerBannerRequired = productOffering === 'dinner'
  const cateringBannerRequired = productOffering === 'catering'
  const [url, setUrl] = useState('')
  const [signupUrl, setSignupUrl] = useState('')
  const isMobile = typeof window != 'undefined' && window.innerWidth < MOBILE_VIEW_BREAKPOINT

  useEffect(() => {
    const position = isGreenPage ? 'green-signup' : landingPageAlias === '' ? 'signup' : `${landingPageAlias}-signup`

    const utmContent = new UtmContent({
      position: landingPageAlias === 'nydinner' ? `${landingPageAlias}-login` : `${productOffering}-login`,
    }).toString()
    const utmContentSignup = new UtmContent({ position: position }).toString()
    if (onPartnerPage) {
      setUrl(UrlService.restaurantLoginUrl())
    } else {
      setUrl(UrlService.loginUrl(utmContent))
    }
    setSignupUrl(UrlService.signupUrl({ utmContent: utmContentSignup, cityName: activeCityName }))
  }, [onNyLunchPage, productOffering, onPartnerPage, onFiveReasonsPage, onSfLunchPage, landingPageAlias, isGreenPage])

  const onClickHandler = () => {
    AnalyticsService.trackEvent({
      action: 'Click',
      category: 'Homepage',
      label: 'Login',
    })

    window.location.href = url
  }

  const logInClasses = () => {
    if (onPartnerPage || isLunchForLessPage) {
      return 'header__lunch-for-less'
    } else if (isGreenPage) {
      return 'header__green-button'
    } else {
      return 'header__action-secondary'
    }
  }

  return (
    <>
      {dinnerBannerRequired ? <DinnerBanner /> : ''}
      {lunchBannerRequired && activeCityName.toLowerCase() === 'new york city' ? <HomepageTopBanner /> : ''}
      {deliveryBannerRequired ? <DeliveryBanner /> : ''}
      {cateringBannerRequired ? <CateringBanner /> : ''}
      <header className={`header${isGreenPage ? '__green' : ''}`}>
        <a {...(isLunchForLessPage ? {} : { href: root })} className="header__logo">
          <img src={`${isGreenPage ? WhiteLogo : Logo}`} />
        </a>

        {isMobile ? (
          <DropdownMenu />
        ) : (
          logInEnabled && (
            <a className={logInClasses()} href={url} onClick={onClickHandler}>
              {t('Log in')}
            </a>
          )
        )}

        {!onPartnerPage && !isLunchForLessPage && (
          <a className={`header__${isGreenPage ? 'green-' : ''}action`} href={signupUrl} onClick={onClickHandler}>
            {t('Join Now')}
          </a>
        )}
      </header>
    </>
  )
}

export default Header
